// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M4 2V20H7V14H12V20H15V11H20V20H22V22H2V2H4ZM16.6734 3.72702L21.2462 8.29984L19.832 9.71406L16.669 6.55103L9.88707 13.2907L5.29307 8.69665L6.70728 7.28244L9.89148 10.4666L16.6734 3.72702Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chart-combo-filled')
export default class ChartComboFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chart-combo-filled',
    }
  }
}
